import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation updateDevice($id: String!, $data: updateDeviceInput!) {
    updateDevice(id: $id, data: $data) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const updateDeviceRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;data: TYPES.UpdateDeviceInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'device/update_device',
  async (
  params: {id: String;data: TYPES.UpdateDeviceInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.updateDevice;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const updateDeviceSlice = createSlice({
  name: 'update_device',
  initialState: initialState,
  reducers: {
    updateDeviceClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(updateDeviceRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(updateDeviceRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(updateDeviceRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { updateDeviceClear } = updateDeviceSlice.actions;

export const updateDevice = createSelector(
  (state: RootState) => state.device.updateDevice.result,
  (state: RootState) => state.device.updateDevice.error,
  (state: RootState) => state.device.updateDevice.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default updateDeviceSlice.reducer;